var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrintIcon = function SvgPrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 9,
    height: 3,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 15,
    height: 8,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5h6"
  }))));
};
export { SvgPrintIcon as ReactComponent };
export default "data:image/svg+xml,%3c!-- 16x16 outlined printer icon --%3e %3csvg version='1.1' id='Lager_1' xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 16 16' xml:space='preserve'%3e %3cg fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'%3e %3c!-- paper --%3e %3crect x='3.5' y='2.5' width='9' height='3' rx='1.25'/%3e %3c!-- printer body --%3e %3crect x='0.5' y='6.5' width='15' height='8' rx='1.5'/%3e %3c!-- output slot --%3e %3cline x1='5' y1='10.5' x2='11' y2='10.5'/%3e %3c/g%3e %3c/svg%3e";